import {currentUserModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;

export const startDownload = function (blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const canAccessExports = function (): boolean {
    return currentUserModule.hasRight(Rights.ChangesExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.StudyCsvExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.SafetyScreeningExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.AkromegalieRewardExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.AkromegalieStatusExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.ChangesExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.QueriesExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.UserQueriesExportGetFilesCmd) ||
        currentUserModule.hasRight(Rights.FinalExportGetCmd) ||
        currentUserModule.hasRight(Rights.QueriesOverviewExportGetFilesCmd)
}
